import { Box, Container, Drawer } from '@material-ui/core'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import EditFeedbackForm from 'src/components/EditFeedbackForm'
import DataTableNew from 'src/components/helperComponents/DataTable/DataTableNew'
import DialogComponent from 'src/components/helperComponents/DialogComponent'
import { DeleteFeedbackById } from 'src/redux/actions'
import { GetFeedbacksColumns } from 'src/util/columns'

const UserFeedbacksList = () => {
  const dispatch = useDispatch()

  const [recordToEdit, setRecordToEdit] = useState()
  const [recordToDelete, setRecordToDelete] = useState()
  const { feedbacks } = useSelector(store => store.mainReducer)

  const onDeleteRow = () => {
    if (recordToDelete) {
      dispatch(DeleteFeedbackById(recordToDelete))
      setRecordToDelete()
    }
  }

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <Drawer
            anchor="right"
            open={!!recordToEdit}
            onClose={() => setRecordToEdit()}
            PaperProps={{
              sx: {
                width: 400,
                top: 64,
                height: 'calc(100% - 64px)',
              },
            }}
          >
            <EditFeedbackForm
              selectedRow={recordToEdit}
              toggleDrawer={() => setRecordToEdit()}
            />
          </Drawer>
          <Box sx={{ pt: 3 }}>
            <DataTableNew
              data={feedbacks}
              columns={GetFeedbacksColumns(setRecordToEdit, setRecordToDelete)}
              apiName="feedbacks"
            />
          </Box>
          {recordToDelete && (
            <DialogComponent
              title="Delete Report"
              description="Do you want to delete the report?"
              onDialogOk={onDeleteRow}
              onDialogCancel={() => setRecordToDelete(!recordToDelete)}
            />
          )}
        </Container>
      </Box>
    </>
  )
}

export default UserFeedbacksList
